import buildAbsoluteUrl from './buildAbsoluteUrl';

// Types

type BuildBreadcrumbListItemInput = {
  name: string;
  position: number;
  url: string;
};

const buildBreadcrumbListItem = ({ name, position, url }: BuildBreadcrumbListItemInput) => {
  return {
    '@type': 'ListItem',
    item: buildAbsoluteUrl(url),
    name,
    position,
  };
};

export default buildBreadcrumbListItem;
